import { fromJS } from 'immutable';

import { ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import {GetAccessModule, GetAccessModuleAction, GlobalLoading} from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'
import {PrevilageId} from '../../../helper/HelperAuth'

export default (menuName) => async (dispatch, getState) => {
    dispatch({ type: GlobalLoading, showLoading: true});

    const Authorization = UserToken;
    const url = ApiUrl2 + 'config-accessmodule-list';
    var paramBody = {
        "query":{
            "privilege-id":PrevilageId,
        }       
    };
    const argument = {  
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
        body : JSON.stringify(paramBody)
    };  

    const response = await doFetch(url,argument);
    var data = fromJS({});
    var resData = fromJS({});
    if(response.ok){
        let array =[]
        let action = 1;
        data = fromJS(await response.json());
        data = data.get('query-result');
        data = data.get('data');
        {data.map((data, i) =>
                array.push({
                  'menu-name' :data.get('menu-name'),
                  'action-id' : data.get('action-id')
                })

            )}
        for (let i = 0; i < array.length; i++) {
          if (array[i]['menu-name'] === menuName) {
            action = array[i]['action-id'];
          }
        }
        resData=  fromJS({
            'success': true,
            'menu-name': menuName,
            'action-id':action
        });
    }
    dispatch({ type: GetAccessModuleAction, data: resData });
    dispatch({ type: GlobalLoading, showLoading: false});
    return resData;
};